<template lang="pug">
div
  .van-popup__header
    .van-popup__header__title {{ $t("iq.title") }}
    van-icon.van-popup__header__close(name='close', @click='$emit("close")')

  .iq__items
    .iq__item
      van-icon(name='iqOff', :class='{ select: aqmode === IQ_MODE.OFF }', @click='setIQ(IQ_MODE.OFF)')
      iq__item__title {{ $t("iq.iqOff") }}
    .iq__item
      van-icon(name='iqOn', :class='{ select: aqmode === IQ_MODE.ON }', @click='setIQ(IQ_MODE.ON)')
      iq__item__title {{ $t("iq.iqOn") }}
    .iq__item
      van-icon(name='iqAuto', :class='{ select: aqmode === IQ_MODE.AUTO }', @click='setIQ(IQ_MODE.AUTO)')
      iq__item__title {{ $t("iq.iqAuto") }}
</template>

<script>
import { IQ_MODE } from '@/app.config';

export default {
  props: {
    aqmode: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      IQ_MODE,
    };
  },

  methods: {
    setIQ(aqmode) {
      this.$emit('setIQ', aqmode);
    },
  },
};
</script>
